import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const createGroupPayloadSchema = t.object({
  label: t.string,
  childNavItemId: t.string
});
const renameGroupPayloadSchema = t.object({
  groupId: t.string,
  label: t.string
});
const removeGroupPayloadSchema = t.object({
  groupId: t.string
});
export let PinnedItemsGroupAction;
(function (PinnedItemsGroupAction) {
  PinnedItemsGroupAction["CREATE"] = "CREATE";
  PinnedItemsGroupAction["RENAME"] = "RENAME";
  PinnedItemsGroupAction["REMOVE"] = "REMOVE";
})(PinnedItemsGroupAction || (PinnedItemsGroupAction = {}));
const pinnedItemsGroupActionSchema = t.union(t.literal(PinnedItemsGroupAction.CREATE), t.literal(PinnedItemsGroupAction.RENAME), t.literal(PinnedItemsGroupAction.REMOVE));
const pinnedItemsGroupChanged = defineMessage({
  type: 'pinned-items-group-changed',
  payloadSchema: t.object({
    action: pinnedItemsGroupActionSchema,
    success: t.boolean,
    label: t.string,
    failureReason: t.optional(t.string)
  })
});
const createGroup = defineMessage({
  type: 'create-pinned-items-group',
  payloadSchema: createGroupPayloadSchema,
  reply: pinnedItemsGroupChanged
});
const renameGroup = defineMessage({
  type: 'rename-pinned-items-group',
  payloadSchema: renameGroupPayloadSchema,
  reply: pinnedItemsGroupChanged
});
const removeGroup = defineMessage({
  type: 'remove-pinned-items-group',
  payloadSchema: removeGroupPayloadSchema,
  reply: pinnedItemsGroupChanged
});
export const pinnedItemsApi = {
  createGroup,
  renameGroup,
  removeGroup,
  pinnedItemsGroupChanged
};